import React, { useCallback, useEffect } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import cookie from 'cookie_js';
import { stringIsNullOrUndefinedOrBlank, isNullOrUndefined } from './siteFunctions';

const AuthorizeRoute = ({ path, children, ...rest }) => {
	const user = useSelector(state => state.ui.user);

	// const _isAuthenticated = useCallback(async () => {
	// 	return user !== undefined && user !== null && user.jwt;
	// }, [user]);

	// useEffect(() => {
	// 	_isAuthenticated();
	// }, [_isAuthenticated]);

	// if (Component === null)
	return (
		<Route
			{ ...rest }
			render={({ location }) =>
				(!isNullOrUndefined(user)) ? (
					children
				) : (
					<Redirect
						to={{
							pathname: '/',
							state: { from: location }
						}}
					/>
				)
			}
		/>
	);
	// else
	// 	return <Route { ...rest } render={props => <Component {...props} />} />;
};

export default AuthorizeRoute;